import axios, { AxiosError } from 'axios';
import { Store } from '@reduxjs/toolkit';
import { logout } from '../features/authSlice';
import { api } from './api/apiClient';

let isHandlingUnauthorized = false;

/** Auth endpoints that can return 401 for bad credentials — don't treat as session expiry */
const AUTH_401_EXCEPTIONS = ['/aut/a/login'];

function isAuthCredentialError(error: AxiosError): boolean {
  const url = error.config?.url || '';
  return AUTH_401_EXCEPTIONS.some(path => url.includes(path));
}

function handleUnauthorized(store: Store) {
  if (isHandlingUnauthorized) {
    return;
  }

  isHandlingUnauthorized = true;
  store.dispatch(logout());
  window.location.href = '/';
}

export function setupAxiosAuthInterceptors(store: Store) {
  const onRejected = (error: AxiosError) => {
    if (error.response?.status === 401 && !isAuthCredentialError(error)) {
      handleUnauthorized(store);
    }

    return Promise.reject(error);
  };

  axios.interceptors.response.use(response => response, onRejected);
  api.axios.interceptors.response.use(response => response, onRejected);
}
